import Utils from '@/ecm/common/Utils'
export default class DistributionDetail {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.userID = 0;
        this.requiresValidation = false;
        this.requiresSignature = false;
        this.singleVisualization = false;
        this.expires = false;
        this.expirationDays = 0
        this.externalUserEmail = "";
        this.infoMessage = "";
        this.editInfoMessage = false;
        this.allowDownload = false;
        this.showAttachments = false;
        this.mergeAttachments = false;

        if (dto) {
            this.userID = parseInt(dto)
        }
    }

    toDto () {
        return {
            UserID: this.userID,
            ExternalUserEmail: this.externalUserEmail,
            RequiresValidation: this.requiresValidation,
            RequiresSignature: this.requiresSignature,
            SingleVisualization: this.singleVisualization,
            ExpirationDays: this.expires ? this.expirationDays : null,
            InfoMessage: this.infoMessage,
            AllowDownload: this.allowDownload,
            ShowAttachments: this.showAttachments,
            MergeAttachments: this.showAttachments && this.mergeAttachments,
        }
    }
}
